import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { config } from '@/lib/helpers'
import { ory } from '@/lib/services'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string>()

  const authorization = computed(() => {
    if (!token.value) {
      return undefined
    }

    return `Bearer ${token.value}`
  })

  const authenticate = async () => {
    try {
      const data = await ory.toSession({ tokenizeAs: 'jwt_default' })
      token.value = data.tokenized
      return !!token.value
    } catch {
      token.value = undefined
      return false
    }
  }

  let refreshPromise: Promise<string | undefined> | null = null

  const refreshToken = (): Promise<string | undefined> => {
    if (refreshPromise === null) {
      refreshPromise = authenticate()
        .then(() => token.value)
        .finally(() => {
          refreshPromise = null
        })
    }
    return refreshPromise
  }

  const logout = async () => {
    const url = new URL('/auth/login', config.identityAppUrl)
    url.searchParams.append('app', 'admin')
    url.searchParams.append('returnUrl', window.location.origin)
    try {
      const data = await ory.createBrowserLogoutFlow({ returnTo: url.toString() })
      return data.logout_url ?? url.toString()
    } catch {
      return url.toString()
    }
  }

  const handleRefreshFailure = () => {
    window.location.href = '/logout'
  }

  return {
    authorization,
    authenticate,
    refreshToken,
    handleRefreshFailure,
    logout,
  }
})
